import { useEffect, useRef } from "react";
import { ToastContentProps } from "react-toastify";
import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useRegisterSW } from "virtual:pwa-register/react";

import { logger as baseLogger } from "@core/logger";
import { AppStore } from "@core/stores";
import { notificationActions } from "@core/stores/notification.store";

const logger = baseLogger.getSubLogger({ name: "SW" });
const intervalMS = 60 * 15 * 1000; // 15 minutes

const UpdateToast = ({ closeToast }: ToastContentProps) => {
  return (
    <Box display="flex" alignItems="center" justifyContent="space-between" flexGrow={1}>
      <Typography variant="body1">A new version of the app is available.</Typography>
      <Button
        color="info"
        onClick={closeToast}
        sx={{
          minWidth: "80px",
          color: "white",
        }}
      >
        Update
      </Button>
    </Box>
  );
};

export const ServiceWorker = () => {
  const app = AppStore;

  const {
    // offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r: any) {
      if (!r) return;
      logger.debug("SW Registered: " + r);
      setInterval(() => {
        void r.update();
        logger.debug("SW Updated");
      }, intervalMS);
    },
    onRegisterError(error: any) {
      logger.debug("SW registration error", error);
    },
  });

  useEffect(() => {
    if (needRefresh) {
      notificationActions.info(UpdateToast, {
        toastId: "update-toast",
        onClose: () => {
          logger.debug("Updating web app");
          updateServiceWorker(true);
        },
        autoClose: false,
      });
    }
  }, [app, needRefresh, updateServiceWorker]);

  return null;
};

ServiceWorker.displayName = "ServiceWorker";
